import { ACL_TYPE } from '@openx/types/aclType';
import type { ThirdPartyFeeConfig } from '@openx/types/deal';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import { useCallback } from 'react';
import { formatThirdPartyFeesConfig } from './formatThirdPartyFeesConfig';

export const useFormatThirdPartyFeesConfig = () => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  const safeFormatThirdPartyFeesConfig = useCallback(
    (isEnabled: boolean, thirdPartyFeesConfig: ThirdPartyFeeConfig[]) => {
      if (!isAllowed(isAllowedByCompiledAcl(ACL_TYPE.THIRD_PARTY_FEES_WRITE))) {
        return undefined;
      }

      return formatThirdPartyFeesConfig(
        isEnabled,
        thirdPartyFeesConfig,
        isAllowed(isAllowedByCompiledAcl(ACL_TYPE.THIRD_PARTY_FEES_PLATFORM_SHARE_WRITE))
      );
    },
    [isAllowed]
  );

  return {
    safeFormatThirdPartyFeesConfig,
  };
};
